import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { headerPermissionService } from '../../_services/Analyze/headerPermission.service';

export const headerPermissionAction = {
    headerPermissionDataAction
}


function headerPermissionDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        headerPermissionService.headerPermissionData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_HEADER_PERMISSSION } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_HEADER_PERMISSSION, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_HEADER_PERMISSSION, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/headerPermission.action.js